module.exports = __webpack_public_path__ + "img/pause-circle.7bb024d3.svg";